import bnc from "bnc";

const block = new bnc("video-wrapper");



const PLAYBACK_RATE: Record<string, {value: number; label?: string}> = {
    slow_0_5   : {value: 0.5},
    normal     : {label: 'Обычная', value: 1},
    fast_1_25  : {value: 1.25},
    fast_1_5   : {value: 1.5},
    fast_1_75  : {value: 1.75},
    fast_2_0   : {value: 2},
};

const NO_DOWNLOAD_ATTRIBUTES = {
    file: {
        attributes: {
            controlsList: 'nodownload'
        }
    }
};

const EXTERNAL_IFRAME_ALLOW = 'autoplay; encrypted-media; fullscreen; picture-in-picture; clipboard-write; screen-wake-lock';

export {
    block,
    PLAYBACK_RATE,
    NO_DOWNLOAD_ATTRIBUTES,
    EXTERNAL_IFRAME_ALLOW
}
